/**
 * Boje i pismo grafikona statistike: iste kao u izveštajima (shared/reportTokens.scss), da smena ima istu boju na
 * grafikonu, u tabeli i na oznaci. Boje nikad nisu jedini nosilac podatka: uz njih su legenda i brojevi.
 */
export const SHIFT_COLORS = ["#0ea5e9", "#14b8a6", "#8b5cf6", "#ec4899"];

/** Preuzeto (zeleno) i poručeno, a nepreuzeto (narandžasto, kao akcent aplikacije). */
export const TAKEN_COLORS = ["#15803d", "#fb923c"];

/** Pismo grafikona prati pismo stranice. */
export const CHART_FONT = "inherit";

export const GRID_COLOR = "#efebe6";

/** Isječak prstena ispod ovog udela nema oznaku (ne stane, a slivao bi se sa susednim). */
export const MIN_DONUT_LABEL = 5;

export const donutLabel = (val) => (val < MIN_DONUT_LABEL ? "" : `${val.toFixed(1)}%`);

/**
 * Naručeno / Preuzeto: udeo preuzetih u ukupno naručenom ("87%") unutar zelenog dela trake i u opisu.
 * Prvi niz je preuzeto, drugi nepreuzeto, a `entries` imaju `taken` i `notTaken`.
 */
export const takenPercent = (entries, index) => {
  const entry = entries[index];
  const total = entry ? entry.taken + entry.notTaken : 0;
  return total > 0 ? Math.round((entry.taken / total) * 100) : 0;
};

export const takenOptions = (entries) => ({
  dataLabels: {
    enabled: true,
    enabledOnSeries: [0],
    formatter: (val, { dataPointIndex }) => `${takenPercent(entries, dataPointIndex)}%`,
    style: { fontSize: "11px", fontWeight: 600, colors: ["#ffffff"] },
    dropShadow: { enabled: false },
  },
  tooltip: {
    shared: true,
    intersect: false,
    y: {
      formatter: (val, { seriesIndex, dataPointIndex }) =>
        seriesIndex === 0 ? `${val} (${takenPercent(entries, dataPointIndex)}%)` : `${val}`,
    },
  },
});
